export default __webpack_public_path__ + "static/media/bgL.cb34da94.webp";